import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'dibs-elements/exports/Button';

import styles from './ContemporaryLandingHeaderModule.scss';

export const ContemporaryLandingHeaderModule = ({
    cta,
    imagePath,
    linkPath,
    subtitle,
    title,
    onClick,
}) => {
    return (
        <div className={styles.wrapper}>
            <div>
                {imagePath ? (
                    <img className={styles.image} src={imagePath} alt={title} />
                ) : (
                    <div className={styles.placeholder} />
                )}
            </div>
            <div className={styles.moduleWrapper}>
                <div className={styles.module}>
                    <div className={styles.title}>{title}</div>
                    {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
                    <Button
                        className={styles.button}
                        href={linkPath}
                        size="medium"
                        onClick={onClick}
                    >
                        {cta}
                    </Button>
                </div>
            </div>
        </div>
    );
};

ContemporaryLandingHeaderModule.defaultProps = {
    onClick: () => {},
};

ContemporaryLandingHeaderModule.propTypes = {
    onClick: PropTypes.func,
    cta: PropTypes.string.isRequired,
    imagePath: PropTypes.string,
    linkPath: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    title: PropTypes.string.isRequired,
};
